/**
 * section-faq-accordion.js — FAQ アコーディオン
 *
 * 機能:
 *  - 質問ボタンクリックで回答をアニメーション展開/折りたたむ
 *  - aria-expanded でアクセシビリティ対応
 *  - 複数同時展開 OK（1つだけにしたい場合は closeOthers を true に）
 */

(function () {
  'use strict';

  const CLOSE_OTHERS = false; // true にすると1つだけ展開モード

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.js-faq-item').forEach(function (item) {
      const toggle = item.querySelector('.js-faq-toggle');
      const answer = item.querySelector('.faq-accordion__answer');

      if (!toggle || !answer) return;

      toggle.addEventListener('click', function () {
        const isOpen = item.classList.contains('is-open');

        // 他を閉じるモード
        if (CLOSE_OTHERS && !isOpen) {
          document.querySelectorAll('.js-faq-item.is-open').forEach(function (other) {
            if (other !== item) closeItem(other);
          });
        }

        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });
  });

  function openItem(item) {
    const toggle = item.querySelector('.js-faq-toggle');
    const answer = item.querySelector('.faq-accordion__answer');

    item.classList.add('is-open');
    toggle.setAttribute('aria-expanded', 'true');

    // hidden 属性を外してアニメーション
    answer.removeAttribute('hidden');
    // 高さアニメーション
    answer.style.maxHeight = '0px';
    answer.style.overflow = 'hidden';
    answer.style.transition = 'max-height 0.3s ease';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        answer.style.maxHeight = answer.scrollHeight + 'px';
      });
    });

    // アニメーション終了後にスタイルをリセット
    answer.addEventListener('transitionend', function handler() {
      answer.style.maxHeight = '';
      answer.style.overflow = '';
      answer.style.transition = '';
      answer.removeEventListener('transitionend', handler);
    });
  }

  function closeItem(item) {
    const toggle = item.querySelector('.js-faq-toggle');
    const answer = item.querySelector('.faq-accordion__answer');

    item.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');

    // 閉じるアニメーション
    answer.style.maxHeight = answer.scrollHeight + 'px';
    answer.style.overflow = 'hidden';
    answer.style.transition = 'max-height 0.3s ease';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        answer.style.maxHeight = '0px';
      });
    });

    // アニメーション終了後に hidden を付ける
    answer.addEventListener('transitionend', function handler() {
      answer.setAttribute('hidden', '');
      answer.style.maxHeight = '';
      answer.style.overflow = '';
      answer.style.transition = '';
      answer.removeEventListener('transitionend', handler);
    });
  }

})();
